import React, { useEffect, useState } from 'react';
import { PiCheckCircleLight } from 'react-icons/pi';

interface MiniLoadingToCheckmarkProps {
  isLoading: boolean;
  spinnerSize?: number;
  checkSize?: number;
  transitionDuration?: number; 
}

const MiniLoadingToCheckmark: React.FC<MiniLoadingToCheckmarkProps> = ({
  isLoading,
  spinnerSize = 16,
  checkSize = 16,
  transitionDuration = 300,
}) => {
  const [phase, setPhase] = useState<'SPINNING' | 'CHECKMARK'>(
    isLoading ? 'SPINNING' : 'CHECKMARK'
  );

  useEffect(() => {
    if (isLoading) {
      setPhase('SPINNING');
    } else {
      const timer = setTimeout(() => {
        setPhase('CHECKMARK');
      }, transitionDuration);

      return () => clearTimeout(timer);
    }
  }, [isLoading, transitionDuration]);

  return (
    <div className="relative flex items-center justify-center" style={{ width: checkSize, height: checkSize }}>
      <div
        className={`
          ${phase === 'SPINNING' ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}
          absolute transition-all duration-300
          flex items-center justify-center
        `}
        style={{ width: spinnerSize, height: spinnerSize }}
      >
        <div
          className="animate-spin rounded-full border-t-2 border-b-2 border-blue-500"
          style={{ width: spinnerSize, height: spinnerSize }}
        />
      </div>

      <PiCheckCircleLight
        className={`
          text-green-500 transition-all duration-300
          ${phase === 'CHECKMARK' ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}
        `}
        style={{ width: checkSize, height: checkSize }}
      />
    </div>
  );
};

export default MiniLoadingToCheckmark;
